<template>
    <a-drawer placement="right" :closable="false" :visible="showDrawer" @close="close" width="70%"
        :style="{ transform: 'none' }" keyboard>
        <div>
            <a-spin v-if="loading" size="large" class="loading" />
            <div v-else>
                <!-- 顶部信息 -->
                <div class="header font">
                    <div class="header-top">
                        <p class="title">{{ headInfo.title }}
                            <span v-if="formParams.enabled == 1" style="color:#00D039 ;">（已发布）</span>
                            <span v-if="formParams.enabled == 0" style="color:#FF0000 ;">（已停用）</span>
                        </p>
                        <p class="time">{{ headInfo.startTime }}开始，{{ headInfo.endTime }}结束</p>
                    </div>
                    <div class="header-bottom font">
                        <div class="teacher-detail" v-for="item in dimensionCountList" :key="item.demensionId">
                            <div class="text">{{ item.dimensionTitle }}</div>
                            <div class="number">{{ item.dimensionCount }}</div>
                        </div>
                    </div>
                    <a class="close-img" @click="close">
                        <img src="../../../../public/close.png" alt="" />
                    </a>
                </div>
                <!-- tab分页 -->
                <a-tabs default-active-key="2">
                    <!-- 基本信息 -->
                    <a-tab-pane key="1" tab="基本信息">
                        <div class="tabs font">
                            <div class="basic">
                                <div class="form" style="width: 575px;margin: 0;">
                                    <div class="form-item">
                                        <div class="label"><span>*</span>对应学期</div>
                                        <div class="item-box">
                                            <a-select style="width: 100%;" disabled v-model="formParams.termId">
                                                <a-select-option v-for="item in termList" :key="item.id">
                                                    {{ item.termName }}
                                                </a-select-option>
                                            </a-select>
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="label"><span>*</span>问卷标题</div>
                                        <div class="item-box">
                                            <a-input v-model="formParams.title" disabled />
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="label2">问卷说明 填写要求</div>
                                        <div class="item-box">
                                            <textarea rows="6" v-model="formParams.contentText" disabled></textarea>
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="label">开始填写</div>
                                        <div class="item-box">
                                            <div>
                                                <a-date-picker format="YYYY年MM月DD日" v-model="formParams.startTime"
                                                    disabled />
                                                <span
                                                    :style="{ display: 'inline-block', width: '80px', textAlign: 'center' }">
                                                    截止提交
                                                </span>
                                                <a-date-picker format="YYYY年MM月DD日" v-model="formParams.endTime"
                                                    disabled />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="label"><span>*</span>下发方式</div>
                                        <div class="item-box">
                                            <a-select style="width: 100%;" :disabled="true"
                                                v-model="formParams.publishIncludeEachClass">
                                                <a-select-option v-for="item in issuedList" :key="item.value">
                                                    {{ item.label }}
                                                </a-select-option>
                                            </a-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="QR">
                                    <div class="QR-border">
                                        <p>微信扫码预览问卷</p>
                                        <a-spin v-if="QrLoading" class="QrLoading" tip="正在生成二维码"></a-spin>
                                        <img :src="formParams.ScanCode" v-else>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </a-tab-pane>
                    <!-- 问卷问题 -->
                    <a-tab-pane key="2" tab="问卷问题">
                        <div class="tabs font">
                            <div class="question">
                                <div class="question-item" v-for="(item, index) in questionList" :key="index">
                                    <div class="options">
                                        <b style="font-size: 16px;color: #1B1D26;;">第{{ index + 1 }}题</b>
                                        <div class="operate" v-show="!item.editing"
                                            v-if="item.dataType == 30 || item.dataType == 35">
                                            <a-button v-if="!item.submitCount" disabled>导出</a-button>
                                            <a-popconfirm title="确认导出该题吗？" @confirm="exportQuestion(item)" v-else
                                                okType="default">
                                                <a-button>导出</a-button>
                                            </a-popconfirm>
                                        </div>
                                    </div>
                                    <div class="content-item">
                                        <div class="label">问题类型</div>
                                        <div class="content">
                                            <div class="ml12" style="height: 32px;line-height: 32px;">
                                                {{ item.dataTypeText }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 满意度 -->
                                    <div v-show="item.dataType == 0">
                                        <div class="content-item">
                                            <div class="label">统计维度</div>
                                            <div class="content">
                                                <div class="ml12">{{ item.dimensionText }}</div>
                                            </div>
                                        </div>
                                        <div class="content-item">
                                            <div class="label">问题标题</div>
                                            <div class="content">
                                                <div class="ml12 etitle">
                                                    {{ item.subjectText }}
                                                    <a-badge v-if="formParams.state == 1 && item.averageValue"
                                                        :count="'平均分：' + item.averageValue"
                                                        :number-style="{ backgroundColor: '#40a9ff' }" class="ml12" />
                                                </div>
                                            </div>
                                        </div>
                                        <div style="display: flex; line-height: 32px;">
                                            <!-- case -->
                                            <div class="label">问题选项</div>
                                            <div class="answers">
                                                <div class="satisfaction" v-for="ele in item.itemCase"
                                                    :class="{ 'tfy': item.itemCase[0].tags && item.itemCase[0].tags.length }"
                                                    :key="ele.dataValue" style="display: flex;">
                                                    <div class="satisfaction-title">
                                                        {{ ele.dataValue }} &nbsp;{{ ele.caseName }}
                                                        <a-badge v-if="formParams.state == 1 && ele.submitPercent"
                                                            :count="ele.submitPercent + '%'"
                                                            :number-style="{ backgroundColor: '#40a9ff' }"
                                                            class="badge1" />
                                                    </div>
                                                    <div class="tag-box"
                                                        style="width:calc(100vw - 100px); padding-top: 2px;">
                                                        <div class="tag" v-for="(e, i) in ele.tags" :key="i"
                                                            style="padding: 0 13px;">
                                                            {{ e.caseName }}
                                                            <a-badge v-if="formParams.state == 1 && e.submitPercent"
                                                                :count="e.submitPercent + '%'"
                                                                :number-style="{ backgroundColor: '#40a9ff' }"
                                                                class="badge2" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 单选及多选 -->
                                    <div v-show="item.dataType == 10 || item.dataType == 20">
                                        <div class="content-item">
                                            <div class="label">问题标题</div>
                                            <div class="content">
                                                <div class="ml12 etitle">{{ item.subjectText }}</div>
                                            </div>
                                        </div>
                                        <div class="content-item case" style="width: 60vw;">
                                            <div class="label">问题选项</div>
                                            <div class="tag-box" style="transform: translateY(-10px);">
                                                <div class="tag" v-for="(e, i) in item.storageTags" :key="i">
                                                    {{ e.caseName }}
                                                    <a-badge v-if="formParams.state == 1 && e.submitPercent"
                                                        :count="e.submitPercent + '%'"
                                                        :number-style="{ backgroundColor: '#40a9ff' }" class="badge2" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 自定义文本 -->
                                    <div v-show="item.dataType == 30 || item.dataType == 35">
                                        <div class="content-item">
                                            <div class="label">问题标题</div>
                                            <div class="content">
                                                <div class="ml12 etitle">
                                                    {{ item.subjectText }}
                                                    <a-badge v-if="formParams.state == 1 && item.submitCount"
                                                        :count="'回答人数：' + item.submitCount"
                                                        :number-style="{ backgroundColor: '#40a9ff' }" class="ml12" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="content-item" style="margin-top: -2px">
                                        <div class="label">是否必填</div>
                                        <div class="content">
                                            <div v-show="!item.editing">
                                                <a-checkbox style="margin: 0 8px 0 12px;" v-model="item.requiredFlag"
                                                    disabled>
                                                </a-checkbox>必填
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>
                    <!-- 班级统计 -->
                    <a-tab-pane key="3" tab="班级统计"
                        v-if="formParams.publishIncludeEachClass !== 0 && formParams.publishIncludeEachClass !== 7">
                        <div class="tabs font">
                            <classStatistics :formId="questionnairId"></classStatistics>
                        </div>
                    </a-tab-pane>
                    <!-- 问卷统计 -->
                    <a-tab-pane key="4" tab="问卷统计">
                        <div class="tabs font">
                            <AnalyticsStatistics :formId="questionnairId"></AnalyticsStatistics>
                        </div>
                    </a-tab-pane>
                    <!-- 问卷清单 -->
                    <a-tab-pane key="5" tab="问卷清单">
                        <div class="tabs font">
                            <QuestionFormList :formId="questionnairId" :type="formParams.publishIncludeEachClass">
                            </QuestionFormList>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </a-drawer>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import questionnaire from '../../../api/questionnaire';
import QuestionFormList from './QuestionFormList.vue';
import classStatistics from './classStatistics.vue';
import AnalyticsStatistics from './AnalysisStatistics.vue';
const typeList = [
    {
        value: 0,
        label: '单选1-5满意度',
    },
    {
        value: 10,
        label: '单选题',
    },
    {
        value: 20,
        label: '多选题',
    },
    {
        value: 30,
        label: '问答题',
    },
];
const issuedList = [
    {
        value: 0,
        label: '下发给所有在册学员',
    },
    {
        value: 7,
        label: '下发给所有参与学员',
    },
    {
        value: 2,
        label: '按社团班级下发',
    },
    {
        value: 1,
        label: '按特色班级下发',
    },
];
export default {
    name: "QuestionnaireDetail",
    components: {
        classStatistics,
        QuestionFormList,
        AnalyticsStatistics
    },
    props: {
        showDrawer: {
            type: Boolean,
            default: false,
        },
        formId: {
            type: Number
        }
    },
    data() {
        return {
            schoolId: Vue.ls.get('schoolId'),
            questionnairId: null,
            termList: [],
            dimFlag: true,
            loading: false,
            QrLoading: false,
            formParams: {},
            headInfo: {},
            dimensionCountList: {}, // 维度统计
            tabIndex: "2", // tab页
            questionList: [],
            typeList, // 问题类型
            issuedList, // 下发方式
            dimension: [], // 维度选项
        };
    },
    created() {
        this.getTermList()
    },
    mounted() {
        this.loading = true
        this.questionnairId = this.formId
        Promise.all([this.getFormInfo(this.formId), this.getQuestionList()]).then(() => {
            this.loading = false
        })
    },
    methods: {
        // 获取学期列表
        async getTermList() {
            const data = await questionnaire.getTermList({ schoolId: this.schoolId })
            if (!data) return
            this.termList = data.data
        },
        // 获取维度
        async getDimensionList() {
            const { data } = await questionnaire.getDimension()
            if (!data) return
            this.dimension = data
        },
        // 查看问卷信息
        async getFormInfo(id) {
            const { data } = await questionnaire.getQuestionnaireDetail(id)
            if (!data) {
                this.$message.error('问卷不存在')
                this.$emit("update:showDrawer", false);
                return
            }
            // console.log(data, '问卷信息')
            if (!data.contentText) data.contentText = '无问卷说明'
            this.handleTopInfo(data)
            data.startTime = moment(data.startTime).format('YYYY-MM-DD')
            data.endTime = moment(data.endTime).format('YYYY-MM-DD')
            this.formParams = data
            this.getQrCode()
        },
        // 获取二维码
        async getQrCode() {
            this.QrLoading = true
            const res = await questionnaire.getQrCode(this.questionnairId)
            if (res.code != 0) return
            // console.log(res, '二维码')
            this.formParams.ScanCode = res.ScanCode
            this.QrLoading = false
            this.$forceUpdate()
        },
        // 获取统计维度数量
        async getDimensionCount() {
            const { data } = await questionnaire.getDimensionCount(this.questionnairId)
            if (!data) return
            // console.log(data, '维度数量')
            this.dimensionCountList = data
            const total = data.reduce((pre, cur) => {
                return pre + cur.dimensionCount
            }, 0)
            this.dimensionCountList.push({
                dimensionTitle: '总计',
                dimensionCount: total
            })
        },
        exportQuestion(item) {
            questionnaire.exportQuestion(this.questionnairId, item.id).then(res => {
                window.open(res.targetUrl)
                this.$message.success('导出成功')
            })
        },
        // 获取问题列表
        async getQuestionList() {
            if (this.dimFlag) {
                await this.getDimensionList()
                this.dimFlag = false
            }
            const { data } = await questionnaire.getQuestionList(this.questionnairId, this.schoolId)
            if (!data.id) return
            this.questionList = data.item ? data.item : []
            this.transformData()
            await this.getDimensionCount()
            // console.log(this.questionList, '处理完')
            this.$forceUpdate()
        },
        // 处理数据
        transformData() {
            this.questionList.forEach((item, index) => {
                item.subjectText = item.subject
                item.dataTypeText = this.typeList.find(e => e.value == (item.dataType == 35 ? 30 : item.dataType)).label
                item.requiredFlag = item.required == 1 ? true : false
                if (item.dataType == 0) {
                    item.itemCase.forEach(e => {
                        e.inputVisible = false
                        e.inputTag = ''
                    })
                    item.tagList = []
                    item.itemCase.forEach(e => {
                        item.tagList.push(e.tags ? e.tags : [])
                    })
                    item.dimensionText = this.dimension.find(e => e.id == item.dimensionId).dimensionTitle
                }
                if (item.dataType == 10 || item.dataType == 20) {
                    item.copyCase = JSON.parse(JSON.stringify(item.itemCase))
                    item.storageTags = item.itemCase.map(e => {
                        return {
                            submitPercent: e.submitPercent,
                            caseName: e.caseName,
                        }
                    })
                    item.itemCase.find((e, i) => {
                        if (e.dataType == 30) {
                            item.haveOther = true
                            item.otherId = e.id
                            item.itemCase.splice(i, 1)
                        }
                    })
                }

            })
        },
        // 处理顶部信息
        handleTopInfo(data) {
            this.headInfo.title = data.title
            this.headInfo.startTime = moment(data.startTime).format('YYYY年MM月DD日')
            this.headInfo.endTime = moment(data.endTime).format('YYYY年MM月DD日')
        },
        // 关闭详情抽屉
        close() {
            this.$emit("update:showDrawer", false);
        },
    },
};
</script>

<style lang="less" scoped>
::v-deep .ant-drawer-body {
    padding: 0;
}

::v-deep .ant-divider {
    margin: 10px 0;
    background-color: #f0f3fb !important;
}

.font {
    font-family: PingFangSC, PingFang SC;
}

.header {
    background-color: #f1fafc;
    padding: 21px 24px 16px;

    .header-top {
        .title {
            font-size: 16px;
            font-weight: bold;
            color: #1B1D26;
            margin-bottom: 4px;

        }

        .time {
            color: rgba(23, 26, 29, 0.6);
        }

        .close {
            width: 22px;
            height: 30px;
            line-height: 30px;

            img {
                width: 20px;
                height: 20px;
            }
        }
    }
}

.header-bottom {
    display: flex;
    margin-top: 28px;

    .teacher-detail {
        margin-right: 50px;
        color: #000;

        .text {
            height: 12px;
            color: #37405f;
            line-height: 12px;
            font-size: 12px;
            margin-bottom: 4px;
        }

        .number {
            font-weight: 600;
            font-size: 16px;
            height: 22px;
            line-height: 22px;
            display: flex;
            align-items: center;
            color: #1B1D26;

            span {
                font-size: 12px;
                line-height: 12px;
            }
        }
    }
}

// tab栏
::v-deep .ant-tabs-tab {
    padding: 12px 24px;
    margin: 0;
    bottom: 0px;
}

::v-deep .ant-tabs-bar {
    border-bottom: none;
    position: relative;
}

::v-deep .ant-tabs-nav-wrap:before {
    content: "";
    position: absolute;
    top: 40px;
    left: 0;
    height: 4px;
    width: 100%;
    z-index: 0;
    background-color: #edf3ef;
}

::v-deep .ant-tabs-ink-bar {
    height: 4px;
    margin-left: 24px;
    width: 56px !important;
    z-index: 1;
}

::v-deep .ant-tabs-tab-active:after {
    content: "";
    position: absolute;
    top: 40px;
    left: 0;
    height: 4px;
    width: 100%;
    background-color: #edf3ef;
}

::v-deep .ant-table-thead th {
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #171a1d;
    line-height: 12px;
    padding: 16px;
}

::v-deep .ant-table-tbody td {
    line-height: 12px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #171a1d;
    padding: 16px;
}

.tabs {
    padding: 14px 24px;
    height: calc(100vh - 207px);
    overflow: auto;
}

// .tabs::-webkit-scrollbar {
//     display: none;
// }

.form {
    margin: 60px auto;
    width: 550px;

    .form-item {
        display: flex;
        margin-bottom: 24px;
    }

    .item-box {
        width: 440px;

        ::v-deep .ant-calendar-picker-input {
            width: 180px;
        }
    }

    .label {
        width: 70px;
        padding-top: 5px;
        line-height: 22px;
        text-align: right;
        margin-right: 16px;

        span {
            color: #D32020;
            margin-right: 4px;
            height: 12px;
            display: inline-block;
            transform: translateY(2px);
        }
    }

    .label2 {
        width: 70px;
        text-align: right;
        padding-top: 6px;
        margin-right: 16px;
        white-space: normal;
        overflow: hidden;
        line-height: 24px;
    }

    .btn {
        width: 154px;
        margin: 44px auto 0;
    }

    textarea {
        width: 100%;
        border: 1px solid rgba(217, 217, 217);
        border-radius: 4px;
        padding: 4px 11px;
        resize: none;
        margin-bottom: -10px;
        line-height: 24px;
    }
}

// 问卷
.question-item {
    width: 100%;
    padding: 20px;
    // color: #171A1D;
    margin-bottom: 24px;
    border-radius: 4px;
    border: 1px solid rgba(126, 134, 142, 0.16);

    .label {
        margin-right: 16px;
        min-width: 56px
    }

    .content-item {
        width: 512px;
        padding: 2px 0;
        margin-bottom: 12px;
        display: flex;
        align-items: center;

        .content {
            flex: 1;
        }
    }

    .case {
        align-items: start;
        line-height: 32px;
        // width: 550px;
    }

    .answers {
        // flex: 1;
        width: 55vw;

        .satisfaction {
            display: flex;
            align-items: center;
            flex: 1;
            margin-bottom: 10px;

            .satisfaction-title {
                position: relative;
                width: 92px;
                margin: 0 26px 0 12px;
            }

            .satisfaction-tags {
                flex: 1;
                border-radius: 4px;
                border: 1px solid rgba(126, 134, 142, 0.16);
                padding-left: 13px;
                overflow: hidden;
            }
        }
    }

}

.tfy {
    transform: translateY(-6px) !important;
}

.ml12 {
    margin-left: 12px;
}

.tag-box {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-left: 12px;
    flex: 1;
    width: 800px;
    // height: 32px;
    transform: translateY(-5px);

    .tag {
        position: relative;
        font-size: 14px;
        padding: 0px 27px;
        height: 32px;
        line-height: 30px;
        margin: 10px 13px 0 0;
        border-radius: 4px;
        border: 1px solid rgba(126, 134, 142, 0.16);
    }
}

.loading {
    height: 100vh;
    width: 100%;
    padding-top: 35%;
}

.options {
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        margin-left: 12px;
        width: 76px;
        height: 36px;
    }
}

.basic {
    display: flex;

    .QR-border {
        padding: 10px 2px;
        border-radius: 8px;
        border: 1px solid silver;
    }

    .QR {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        p {
            font-size: 16px;
            color: #000;
            text-align: center;
        }

        img {
            margin-top: 20px;
            width: 280px;
            height: 280px;
        }

        .QrLoading {
            margin-top: 20px;
            width: 280px;
            height: 280px;
            padding-top: 40%;

            ::v-deep .ant-spin-text {
                color: silver;
                margin-top: 10px;
            }
        }
    }
}

.etitle {
    display: flex;
    align-items: center;
    width: calc(70vw - 192px);
}

.badge1 {
    position: absolute;
    right: -35px;
    top: -4px;
}

.badge2 {
    position: absolute;
    right: -14px;
    top: -12px;
}

.close-img {
    position: absolute;
    top: 25px;
    right: 26px;
}
</style>